import { useEffect, useState } from "react";

import { get_pac_settings } from "../utils/FeedInterface";
import SettingStruct from "../utils/SettingStruct";

export default function useSettings (  )
{
  const [ settings, set_settings ] = useState({  });
  const [ error, set_error ] = useState({  });
  const [ loading, set_loading ] = useState( true );

  // HOOKS ::::::::::::::::
  //
  useEffect(() => {
    get_settings();
  }, [  ] );

  return { settings, error, loading };

  // FUNCTIONS ::::::::::::
  function get_settings ( )
  {
    get_pac_settings( ).then( re => {

      // console.log( 'setting current settings HOOK :: ', re );
      set_settings( re ); // set return settings.

      // set settings data and store struct
      SettingStruct( re );

    }).catch( err => {
      set_error( err );

    }).finally(() => {

      set_loading( false );
    });
  }

}
